import { render, staticRenderFns } from "./k-tooltip.vue?vue&type=template&id=5508ecf1&scoped=true"
import script from "./k-tooltip.vue?vue&type=script&lang=js"
export * from "./k-tooltip.vue?vue&type=script&lang=js"
import style0 from "./k-tooltip.vue?vue&type=style&index=0&id=5508ecf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5508ecf1",
  null
  
)

export default component.exports